/**
 * 語言切換按鈕組件
 * 提供切換應用程式語言的按鈕
 */
import { useTranslation } from "react-i18next";
import { NavbarActionToggle } from "./NavbarActionToggle";
import { LanguageToggleButtonProps } from "./types";
import { useLanguage } from "@/application/services/languageService";
import { LOCALES } from "@/domain/constants/locales";

export function LanguageToggleButton({
  className = "",
}: LanguageToggleButtonProps) {
  const { t, i18n } = useTranslation();
  const { toggleLanguage } = useLanguage();

  return (
    <NavbarActionToggle
      onClick={toggleLanguage}
      ariaLabel={t("common.toggleLanguage")}
      title={t("common.toggleLanguage")}
      className={className}
    >
      <span className="text-sm font-medium text-[0.85rem]">
        {i18n.language === LOCALES.ZH_TW ? "EN" : "中"}
      </span>
    </NavbarActionToggle>
  );
}
